
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profil/[id]/bukti-karya/[category]",
      function () {
        return require("private-next-pages/profil/[id]/bukti-karya/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profil/[id]/bukti-karya/[category]"])
      });
    }
  